export const questionQueryKeys = {
  all: ['questions'] as const,
  questions: () => [...questionQueryKeys.all, 'question'] as const,
  question: (surveyId: string, questionId: string) =>
    [...questionQueryKeys.questions(), surveyId, questionId] as const,
  questionsBySurvey: (surveyId: string) =>
    [...questionQueryKeys.all, 'by-survey', surveyId] as const,
  questionStats: (surveyId: string) => [...questionQueryKeys.all, 'stats', surveyId] as const,

  // Template question keys
  templateQuestions: () => [...questionQueryKeys.all, 'template'] as const,
  templateQuestion: (tenantId: string, templateId: string, questionId: string) =>
    [...questionQueryKeys.templateQuestions(), tenantId, templateId, questionId] as const,
  questionsByTemplate: (tenantId: string, templateId: string) =>
    [...questionQueryKeys.all, 'by-template', tenantId, templateId] as const,
};
